export default __webpack_public_path__ + "static/media/Zahtev za dobijanje kartice pogodnosti Nas heroj.008d07c7.pdf";